import { AidaService } from '@adaptiva/ai/common';
import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';
import { EBuiltInIds, hasAllRolesPrereq, hasSomeProductsPrereq } from '@adaptiva/data-service';
import { inject } from '@angular/core';

const _productName: string = Licensing.Products.OneSite.INVENTORY;
const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(_productName);

export const INVENTORY_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: _productName,
	route: _baseUrl,
	sidenav: {
		productName: _productName,
		sections: [
			{
				items: [
					{
						display: 'AI-powered Inventory',
						icon: 'faSparkles',
						showAsButton: true,
						prerequisites: [
							hasAllRolesPrereq(EBuiltInIds.ROLE_SUPER_ADMIN_ID),
							hasSomeProductsPrereq(Licensing.Products.AddOns.AII)
						],
						onSelect: () => {
							const _aida: AidaService = inject(AidaService);

							if (!_aida.isEnabled())
								throw new Error('AI features are not enabled');

							_aida.isOpen.set(true);
						}
					}
				]
			},
			{
				title: 'Device Inventory',
				items: [
					{
						display: 'Home',
						route: `${_baseUrl}`,
						icon: 'faHome',
					},
					{
						display: 'Inventory Strategies',
						route: `${_baseUrl}/strategies`,
						icon: 'faClipboard',
						linkedRoutes: [`${_baseUrl}/strategies/edit/:id`]
					},
					{
						display: 'Inventory Categories',
						route: `${_baseUrl}/categories`,
						icon: 'faGrid2',
						linkedRoutes: [`${_baseUrl}/categories/edit/:id`]
					},
					{
						display: 'Sensor Dashboards',
						route: `${_baseUrl}/sensor-dashboards`,
						icon: 'faChartColumn',
						linkedRoutes: [`${_baseUrl}/sensor-dashboards/:id`]
					},
				]
			}
		],
	}
};
